import { react, useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import CountUp from 'react-countup';
import Image from 'mui-image';
import TokenService from '../services/TokenService'

const DonationTotals = () => {

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if (isLoading == true) {
            //PickupRequest_LoadInitial

            let postData = {
                referrer: window.document.referrer,
                path: window.location.search
            }
    
            TokenService.post(postData, 'PickupRequest_LoadInitialV2', '')
                .then((response) => {
                    if (response !== null) {
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            let jsonData = JSON.parse(response.JsonData);
                            setDonationTotal(jsonData.DonationTotal);
                            setTotalCansRecycled(jsonData.TotalCansRecycled);
                            setCustomerPayout(jsonData.CustomerPayout);
                            TokenService.setWebToken(jsonData.WebToken);
                            setisLoading(false);
                        }
                    }
                })
                .catch((response) => {
                    if (response !== null) {

                    }
                });
        }
    });

    const [isLoading, setisLoading] = useState(true);
    const [DonationTotal, setDonationTotal] = useState(0);
    const [TotalCansRecycled, setTotalCansRecycled] = useState(0);
    const [CustomerPayout, setCustomerPayout] = useState(0);
    let panel;

    function buildLoadingPanel() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50px"
            >
                <CircularProgress color="secondary" />
            </Box>
        )

    }

    if (isLoading) {
        panel = buildLoadingPanel();
    } else {
        panel =
            <div>
                <div style={{ fontSize: '20px', fontWeight: 'bold', display: 'flex', justifyContent:'center' }}>
                    <div></div>
                    <div>Total Recycled:
                        <CountUp
                            separator=","
                          
                            start={0}
                            end={TotalCansRecycled}
                            duration={.75}
                            />
                    </div>
                    <div></div>
                </div>
                {/*<div style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '5px', display: 'flex', justifyContent: 'center' }}>*/}
                {/*    <div></div>*/}
                {/*    <div style={{alignSelf:'flex-end'} }>Paid to Customers: $*/}
                {/*        <CountUp*/}
                {/*            separator=","*/}
                          
                {/*            start={0}*/}
                {/*            end={CustomerPayout.replace('$', '').replace(',', '')}*/}
                {/*            duration={.5}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*    <div style={{marginLeft:'5px'} }>*/}
                {/*        <Image src='/images/payout.png' style={{ height:'50px', width: '80px' }} />*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ marginRight: '5px' }}>
                        <Image src='/images/DonateIcon.png' style={{ maxHeight: '50px' }} />
                    </div>
                    <div style={{ alignSelf: 'flex-end' } }>Charitable Donations: $
                        <CountUp
                            separator=","
                           
                        start={0}
                            end={DonationTotal.replace('$', '').replace(',', '')}
                        duration={.5}
                        />
                    </div> 
                    <div></div>
                </div>
            </div>;
    }

    return (
        panel
    )


}

export default DonationTotals;